import axios from 'axios';
import tryGet from '../../utils/try-get';
import { DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS } from "../../constants/default-values";

const state = {
  listNotMatchRelationships: [],
  listFavoriteRelationships: [],
  listPreviousMatchCandidatesOfEmployer: [], // Of Employer
  listNotMatchEmployerIds: null // List not match employer ids of current candidate
};

const mutations = {
  loadListNotMatchRelationships(state, relationships) {
    state.listNotMatchRelationships = relationships;
  },
  loadListFavoriteRelationships(state, relationships) {
    state.listFavoriteRelationships = relationships;
  },
  setListPreviousMatchCandidatesOfEmployer(state, payload) {
    state.listPreviousMatchCandidatesOfEmployer = payload;
  },
  setListNotMatchEmployerIds(state, payload) {
    state.listNotMatchEmployerIds = payload;
  }
};

const actions = {
  loadListFavoriteAndNotMatchRelationships({ commit, state, rootState }) {
    return new Promise(async (resolve) => {
      const res = await axios.get(
        `/get-relationships/?agency=${rootState.authentication.agencyID}&main_info_only=true&statuses=Do Not Match,Favorite`
      );
      const listRelationships = res.data.relationships;
      commit("loadListFavoriteRelationships", listRelationships.filter(item => item.status === 'Favorite'));
      commit("loadListNotMatchRelationships", listRelationships.filter(item => item.status === 'Do Not Match'));
      resolve();
    });
  },
  getPreviousMatchList({ commit }, { candidateId }) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/get-previous-match-list/?candidate=${candidateId}`)
      if (res && res.data && res.data.employers) {
        resolve(res.data.employers);
      } else {
        resolve([]);
      }
    });
  },
  getRelationshipsByCandidate({ commit }, { id, status }) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/api/relationships/?candidate=${id}&status=${status}`);
      if (res && res.data) {
        resolve(res.data);
      } else {
        resolve([]);
      }
    });
  },
  getRelationshipsByEmployer({ commit }, { id, status }) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/api/relationships/?employer=${id}&status=${status}`);
      if (res && res.data) {
        resolve(res.data);
      } else {
        resolve([]);
      }
    });
  },
  loadPreviousMatchCandidatesByEmployer({ commit, dispatch }, employerId) {
    return new Promise(async (resolve) => {
      let result = [];
      if (employerId) {
        const res = await axios.get(`/get-fillers-by-poster/?poster=${employerId}`);
        if (res && res.data && res.data.fillers) {
          result = res.data.fillers;
        }
      }
      commit('setListPreviousMatchCandidatesOfEmployer', result);
      resolve();
    });
  },
  async loadListNotMatchEmployerIds({ commit, dispatch, state, rootGetters }, userId) {
    if (!userId) {
      userId = rootGetters.userID;
    }
    if (rootGetters.userID === userId) {
      if (state.listNotMatchEmployerIds) {
        return state.listNotMatchEmployerIds;
      }
    }
    const listRelationships = await dispatch('getRelationshipsByCandidate', {
      id: userId,
      status: "Do Not Match",
    });

    const listNotMatchEmployerIds = listRelationships.map(
      (relationship) => relationship.employer
    );
    if (rootGetters.userID === userId) {
      commit('setListNotMatchEmployerIds', listNotMatchEmployerIds);
    }
    return listNotMatchEmployerIds;
  }
};

const getters = {
  listNotMatchEmployerIds(state) {
    return state.listNotMatchEmployerIds || []
  },
  listNotMatchRelationships(state) {
    return state.listNotMatchRelationships;
  },
  listFavoriteRelationships: state => tryGet(() => state.listFavoriteRelationships) || [],
  candidateEmployerRelationshipStatuses(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.candidate_client_relationship_status;
      if (result && result.length) {
        return result;
      }
    }
    return DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS;
  },
  candidateCanMarkClientAsFavorite: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_can_mark_client_favorite) || false,
  candidateCanMarkClientAsDoNotWantAgain: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_can_mark_client_do_not_want_again) || false,
  listPreviousMatchCandidatesOfEmployer: (state) => state.listPreviousMatchCandidatesOfEmployer
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/relationships.js